// Hooks
import useApi from "./useApi"

// Utils & misc
import { API_STAGES_URL } from "../../constants/constants"

const useTypesApi = () => {
  const [requestState, payload, error, request] = useApi()

  const getTypes = () => request("GET", `${API_STAGES_URL}/v1/types`)

  const updateType = type =>
    request("PUT", `${API_STAGES_URL}/v1/types/${type.id}`, type)

  const createType = type => request("POST", `${API_STAGES_URL}/v1/types`, type)

  return [
    requestState,
    payload,
    error,
    {
      getTypes,
      updateType,
      createType,
    },
  ]
}

export default useTypesApi
